import { layout } from '../../App.routing'

export const telethonCountdown = layout.nestedComposition({
    type: 'box',
    props: {
        verticalSpacing: 'lg',
    },
    contentAreas: {
        main: [
            layout.component({
                type: 'telethon-countdown',
                feature: 'telethon-countdown',
                props: {
                    targetDate: new Date('Sat Oct 17 2026 19:00:00 GMT+0800'),
                },
            }),
        ],
    },
})
